/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'monetization';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v2/owner
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:MonetizationServiceV2Resource+type:symbol+getNurturingOwnerInfo&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Basic-get-%2Fmonetization%2Fv2%2Fowner'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv2%2Fowner?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getOwnerRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v2/owner'])
});